'use client'

import { useEffect } from 'react'
import { pfetch } from '@/lib/phishtrainer/play-api'

const SESSION_KEY = 'pt_session_token'

interface Props {
  userId: string
}

export function AnonMerge({ userId }: Props) {
  useEffect(() => {
    if (typeof window === 'undefined') return
    const sessionToken = window.localStorage.getItem(SESSION_KEY)
    if (!sessionToken) return

    pfetch('/api/phishtrainer/inbox-calls/merge', {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ userId, sessionToken }),
    })
      .then((r) => {
        if (r.ok) {
          // Clear the token so we don't keep trying to merge an empty session.
          window.localStorage.removeItem(SESSION_KEY)
        }
      })
      .catch(() => {
        // Silent — merge is a best-effort claim, not a critical path.
      })
  }, [userId])

  return null
}
